export const ComponentHeight = {
  sm: 32,
  md: 40,
  lg: 48,
  xl: 64,
}

export const ComponentFontSize = {
  sm: 14,
  md: 14,
  lg: 16,
  xl: 16,
}

export const ComponentLineHeight = {
  sm: 20,
  md: 20,
  lg: 24,
  xl: 24,
}

export const ComponentLetterSpacing = '0.01em'

export const ComponentIconSize = {
  sm: 18,
  md: 18,
  lg: 24,
  xl: 24,
}

export const ComponentBorderRadius = {
  sm: 4,
  md: 4,
  lg: 4,
  xl: 4,
}

export const ComponentBorderWidth = 1

export const ComponentFocusRectWidth = 2

export const ComponentFocusRectBorderRadius = 4

export const ComponentPaddingX = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 32,
}

export const ComponentPaddingY = {
  sm: 6,
  md: 10,
  lg: 12,
  xl: 20,
}
